export default class DataGUI {
  constructor(data) {
    const gui = new dat.GUI();

    this.gui = gui;
    this.data = data;

    this.addSlider(data.camera.position, 'CameraPosition', 200, 10);
    this.addSlider(data.lights.position, 'Lights', 1000, 50);
    this.addSlider(data.blocks.rotation, 'BlocksRotation', 5, 1);
    this.addSlider(data.sphere.rotation, 'SphereRotation', 1, 0.05);
    this.addSlider(data.innerSphere.rotation, 'InnerSphereRotation', 1, 0.05);
  }

  addSlider(selectedData, title, delta, step, isOpen = true) {
    const data = this;
    const folder = this.gui.addFolder(title);

    Object.keys(selectedData).forEach(param => {
      folder
        .add(selectedData, param)
        .name(param)
        .min(selectedData[param] - delta)
        .max(selectedData[param] + delta)
        .step(step)
      ;
    });

    isOpen && folder.open();

  }
}



/** WEBPACK FOOTER **
 ** ./src/DataGUI.js
 **/